import { Link } from "react-router-dom";
import { WarningCircle } from "@phosphor-icons/react";

export default function ArticleDisclaimer() {
  return (
    <aside
      data-testid="article-disclaimer"
      role="note"
      aria-label="Editorial disclaimer"
      className="mt-10 border-l-4 border-foreground pl-5 py-4 bg-muted/40"
    >
      <div className="flex items-start gap-3">
        <WarningCircle size={18} className="text-foreground/80 mt-0.5 flex-shrink-0" />
        <div>
          <div className="overline mb-1">Editorial disclaimer</div>
          <p className="text-sm text-foreground/80 leading-relaxed">
            This article is provided for general educational purposes only and does
            not constitute investment, tax, legal, or financial advice. Historical
            performance is not a reliable indicator of future results. Always consult
            a qualified fiduciary advisor before acting on any information you read
            here. See our{" "}
            <Link to="/terms" className="underline hover:text-primary">Terms</Link>
            {" "}and{" "}
            <Link to="/privacy" className="underline hover:text-primary">Privacy Policy</Link>.
          </p>
        </div>
      </div>
    </aside>
  );
}
